import { render, staticRenderFns } from "./TestTab.vue?vue&type=template&id=70aa0958&scoped=true&"
import script from "./TestTab.vue?vue&type=script&lang=js&"
export * from "./TestTab.vue?vue&type=script&lang=js&"
import style0 from "./TestTab.vue?vue&type=style&index=0&id=70aa0958&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70aa0958",
  null
  
)

export default component.exports